import { getFileFromUser } from '@weblite/file'
import { useCallback, useState } from 'react'
import {
  CreateWorkspace,
  reqCreateWorkspace,
} from '@weblite/ts-action/workspace'

import { TextInput } from '$common/input'
import { PrimaryButton, SelectButton } from '$common/buttons'
import { request } from '$setup/ws'
import { showWorkspaceCreatedSuccessfully } from '$comp/snackbars'
import { uploadImage } from '$func/upload-image'

export function UserProfileSuperUserWorkspace() {
  const [name, setName] = useState('')
  const [shortName, setShortName] = useState('')
  const [description, setDescription] = useState('')
  const [color, setColor] = useState('')
  const [icon, setIcon] = useState('')

  const onSubmit = useCallback(async () => {
    const res = await request<CreateWorkspace>(
      reqCreateWorkspace({ name, shortName, description, color, icon }),
    )
    if (res.error) {
      console.warn(res.error)
      return
    }
    showWorkspaceCreatedSuccessfully()
  }, [name, shortName, description, color, icon])
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        padding: '16px',
      }}
    >
      <TextInput
        size="small"
        placeholder="name"
        onChange={setName}
        value={name}
      />
      <TextInput
        size="small"
        placeholder="short name"
        onChange={setShortName}
        value={shortName}
      />
      <TextInput
        size="small"
        placeholder="description"
        onChange={setDescription}
        value={description}
      />
      <TextInput
        size="small"
        placeholder="color"
        onChange={setColor}
        value={color}
      />
      <SelectButton
        placeholder="icon"
        onClick={() =>
          getFileFromUser(
            'image/*',
            async file => {
              const selectedFile = Array.isArray(file) ? file[0] : file

              await uploadImage(selectedFile, ({ fileId }) => {
                setIcon(fileId)
              })
            },
            false,
          )
        }
        value={icon}
      />
      <PrimaryButton
        fullWidth
        disabled={!name || !shortName || !color || !icon}
        text="submit"
        onClick={onSubmit}
      />
    </div>
  )
}
